import Icon from '../components/Icon.vue'

Icon.register({
  child: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M120 72C120 32.2 152.2 0 192 0S264 32.2 264 72C264 111.8 231.8 144 192 144S120 111.8 120 72zM374.6 73.4C362.1 60.9 341.9 60.9 329.4 73.4L242.7 160H141.3L54.6 73.4C42.1 60.9 21.9 60.9 9.4 73.4-3.1 85.9-3.1 106.1 9.4 118.6L104 213.3V480C104 497.7 118.3 512 136 512H152C169.7 512 184 497.7 184 480V368H200V480C200 497.7 214.3 512 232 512H248C265.7 512 280 497.7 280 480V213.3L374.6 118.6C387.1 106.1 387.1 85.9 374.6 73.4z'
      }
    ]
  }
})
